import React, { useState, useCallback } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { getByDateRange, create, deletePdata } from '../../services/pdataService';

/*
const formatDate = (dateString) => {//converts date to mm/dd/yyyy
  const date = new Date(dateString);
  return date.toLocaleDateString();
};*/

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  };

  const formattedDate = date.toLocaleDateString('en-GB', options);
  const formattedTime = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  return `${formattedDate} ${formattedTime}`;
}; 

/*const formatTime = (dateString) => {//converts date to hh:mm am/pm
  const date = new Date(dateString);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};*/
function WeightList({ weights, onDelete }) {
  if (!weights || weights.length === 0) return null;

  return (//change to table with 3 columns date, weight, delete button 
    <table className="p-datatable p-component" style={{ width: '100%' }}>
      <thead> 
        <tr>    
          <th>Date</th>
          <th>Weight</th>
          <th></th>
        </tr>
      </thead>  
      <tbody>
        {weights.map((entry) => (
          <tr key={entry._id}>
            <td><b>{formatDate(entry.createdAt)}</b></td>
            <td>{parseFloat(entry.value.$numberDecimal)} lbs</td> 
            <td>
              <Button /** only todays data you can delete */
               /** visible={new Date(entry.createdAt).toDateString() === new Date().toDateString()} **/
                icon="pi pi-times"
                rounded
                text
                severity="danger"
                className="p-button-sm"
                style={{ width: '1.75rem', height: '1.75rem' }}
                onClick={() => onDelete(entry._id)}
                aria-label="Delete entry"
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    
  );
}

const TestWidget = () => {
  const [value, setValue] = useState('');
  const [valueError, setValueError] = useState('');

  //const [yesterdayWeight, setYesterdayWeight] = useState(null);
  //const [todayWeight, setTodayWeight] = useState(null);
  const [weekAgoWeight, setWeekAgoWeight] = useState(null);

  const validateName = (value) => {
    if (!value || !value.toString().trim()) {
      return 'Weight is required';
    }
    if (isNaN(Number(value))) {
      return 'Weight must be a number';
    }
    return '';
  };
/*
  const getTodayData = useCallback(async () => {
    try {
      const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
      const data = await getByDate(today);
      console.log('Today\'s data:', data);
      setTodayWeight(data.pdatas);
    } catch (error) {
      console.error('Error fetching today\'s data:', error);
    }
  }, []);*/
/*
  const getYesterdayData = useCallback(async () => {
    try {
      const yesterday = new Date(); // Get yesterday's date
      yesterday.setDate(yesterday.getDate() - 1);
      const data = await getByDate(yesterday.toISOString().split('T')[0]);
      console.log('Yesterday\'s data:', data);
      setYesterdayWeight(data.pdatas);
    } catch (error) {
      console.error('Error fetching yesterday\'s data:', error);
    }
  }, []);*/

  const getWeekAgoData = useCallback(async () => {
    let today = new Date();
    //7 days ago
    let weekAgo = new Date(today.getTime() - (90 * 24 * 60 * 60 * 1000));
    try {
      const data = await getByDateRange(weekAgo.toISOString().split('T')[0], today.toISOString().split('T')[0]);
      console.log('Date range data:', data);
      //sort by date descending
      data.pdatas.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setWeekAgoWeight(data.pdatas);
    } catch (error) {
      console.error('Error fetching date range data:', error);    
    }    
  }, []);

  React.useEffect(() => {
   // getYesterdayData();
   // getTodayData();
    getWeekAgoData();
  }, [ getWeekAgoData]);

  const handleCreateClick = async () => {
    const error = validateName(value);
    if (error) {
      setValueError(error);
      return;
    }
    setValueError('');

    try {
      const newValue = { value: value, type: 'weight' };
      const createdTest = await create(newValue);
      console.log('Created test:', createdTest);
      setValue('');
      // getYesterdayData();
      // getTodayData();
      getWeekAgoData();
    } catch (error) {
      console.error('Error creating test:', error);
      console.log('Error details:', error.response ? error.response.data : error.message);
    }
  };

  const deleteWeight = async (id) => {
    // Confirm deletion with the user
    let confirmDelete = window.confirm('Are you sure you want to delete this entry?');
    if (!confirmDelete) {
      return; // User canceled the deletion
    }
    try {
      await deletePdata(id);
      // getYesterdayData();
      // getTodayData();
      getWeekAgoData();
    } catch (error) {
      console.error('Error deleting test:', error);
    }
  };

  const confirmDeleteWeight = (id) => {
    confirmDialog({
      message: 'Are you sure you want to delete this entry?',
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-danger',
      accept: () => deleteWeight(id),
    });
  };

  return (
    <Card className="w-full">
      <ConfirmDialog />
      <div className="flex flex-column gap-3">
        <div className="flex align-items-center justify-content-between">
          
          <div className="flex align-items-start gap-2">
            <div className="flex flex-column">
              {valueError && <small className="p-error mb-1">{valueError}</small>}
              <InputText
                type="number"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Enter value in lbs"
                className={valueError ? 'p-invalid' : ''}
              />
            </div>

            <Button label="Add" icon="pi pi-plus" onClick={handleCreateClick} />
          </div>
        </div>
        <div className="flex flex-column gap-2">
         {/*{yesterdayWeight && yesterdayWeight.length > 0 ? (
            <div>
              <strong>Yesterday's Weight:</strong>
              <WeightList weights={yesterdayWeight} onDelete={confirmDeleteWeight} />
            </div>
          ) : (
            <div>No data for yesterday.</div>
          )}

          {todayWeight && todayWeight.length > 0 ? (
            <div>
              <strong>Today's Weight:</strong>
              <WeightList weights={todayWeight} onDelete={confirmDeleteWeight} />
            </div>
          ) : (
            <div>No data for today.</div>
          )}*/}
          {weekAgoWeight && weekAgoWeight.length > 0 ? (
            <div>
              <strong>Last 7 Days Weight:</strong>
              <WeightList weights={weekAgoWeight} onDelete={confirmDeleteWeight} />
            </div>
          ) : (
            <div>No data for last 7 days.</div>
          )}  

        </div>
      </div>
    </Card>
  );
};

export default TestWidget;
